import React from 'react';
import AppRoutes from "./routes/AppRoutes";
import { createTheme, ThemeProvider as MuiThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { ThemeProvider } from '@mui/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const theme = createTheme({
  palette: {
    primary: {
      main: '#174A84',
    },
    secondary: {
      main: '#ff4040',
    }
  },
  typography: {
    fontFamily: [
      'lato',
    ].join(','),
  },
});

const App = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <StyledEngineProvider injectFirst>
        <MuiThemeProvider theme={theme}>
          <ThemeProvider theme={theme}>
            <AppRoutes />
          </ThemeProvider>
        </MuiThemeProvider>
      </StyledEngineProvider>
    </LocalizationProvider>
  );
}

export default App;
